import React from "react";
import { Flame } from "lucide-react";

const StreakBadge = ({ streak, compact = false, testIdPrefix = "streak" }) => {
  if (!streak) return null;
  const { current = 0, longest = 0, active_today, next_milestone, next_milestone_bonus } = streak;
  const onFire = current > 0;

  return (
    <div
      data-testid={`${testIdPrefix}-badge`}
      className={[
        "inline-flex items-center gap-2 px-3 py-1.5 border rounded-sm font-mono text-xs",
        onFire
          ? "bg-orange-400/10 border-orange-400/40 text-orange-200"
          : "bg-white/5 border-white/10 text-slate-400",
      ].join(" ")}
      title={
        onFire
          ? `${current}-day Tam streak${
              next_milestone
                ? ` — next bonus: +${next_milestone_bonus} tokens at ${next_milestone} days`
                : ""
            }`
          : "No active streak — chat with Tam to start one"
      }
    >
      <Flame
        size={14}
        className={onFire ? "text-orange-300" : "text-slate-500"}
        fill={onFire ? "currentColor" : "none"}
      />
      <span data-testid={`${testIdPrefix}-current`}>
        {onFire ? `${current}-day streak` : "No streak"}
      </span>
      {!compact && longest > current && (
        <span className="text-slate-500">· best {longest}</span>
      )}
      {!compact && !active_today && onFire && (
        <span className="ml-1 px-1.5 py-0.5 bg-orange-400/20 text-orange-300 text-[10px] rounded-sm">
          Don't break it
        </span>
      )}
    </div>
  );
};

export default StreakBadge;
